import { rankWith, uiTypeIs } from "@jsonforms/core"

export const UGroupContainerTester = rankWith(1000, uiTypeIs("Group"))
